export function PageLoader() {
  return (
    <div className="flex items-center justify-center min-h-[50vh] py-16">
      <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600" />
    </div>
  );
}
